<div class="headline-small mb-2 md:mb-4" [innerText]="'Voucher.Title' | translate"></div>

<div class="flex items-baseline headline-x-small mb-2">
  <i class="fa-light fa-ticket"></i>
  <div class="flex flex-wrap pl-2">
    <span [innerText]="'Voucher.Redeem' | translate"></span>
  </div>
</div>

<form [formGroup]="voucherForm" (ngSubmit)="handleSubmit()">
  <div class="card card-small md:mb-4 mb-8 lg:w-3/4 2xl:w-1/2">
    <div class="card-body flex flex-col md:flex-row gap-4 md:gap-12 justify-between">
      <div class="ar-input-group mb-2 flex-grow">
        <div class="input-primary-container">
          <input id="code" class="input-primary" addEmptyPlaceholder formControlName="code" />
          <label for="code" [innerText]="'Voucher.Code' | translate"></label>
        </div>
        <p class="error text-left" *formError="'code.serverError'" [innerText]="voucherForm.get('code')?.errors?.['serverError']"></p>
      </div>
      <div class="w-full md:w-fit">
        <button class="button-primary w-full" [innerText]="'Voucher.Redeem' | translate" type="submit"></button>
      </div>
    </div>
  </div>
</form>

<div class="flex items-baseline headline-x-small mb-2">
  <i class="fa-light fa-tickets"></i>
  <div class="flex flex-wrap pl-2">
    <span [innerText]="'Voucher.Vouchers' | translate"></span>
  </div>
</div>

<div class="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-5 mt-2">
  @for (voucher of vouchers; track voucher.id) {
    <div
      class="card flex flex-col"
      [ngClass]="{
        grayscale: voucher.status === 'expired',
        'border-success': voucher.status === 'active',
        'border-warning': voucher.status === 'planned',
      }"
    >
      <div class="card-body inline-flex w-full">
        <div
          class="mr-4"
          [ngClass]="{
            'text-success': voucher.status === 'active',
            'text-warning': voucher.status === 'planned',
          }"
        >
          <i
            class="text-4xl fa-light mt-1"
            [ngClass]="{
              'fa-tickets-perforated': voucher.type === 'multiple',
              'fa-ticket-perforated': voucher.type === 'single',
            }"
            [matTooltip]="'Voucher.Type.' + voucher.type | translate"

          ></i>
        </div>
        <div class="flex items-center w-full">
          <div class="w-100">
            <div class="body-large">{{ voucher.name }}</div>
            <div class="body-medium text-neutral-50">
              {{ voucher.code }}
            </div>
          </div>
          <div class="ml-auto flex items-start h-full">
            <div
              class="inline-flex items-center justify-center rounded-full border px-3 py-1.5 whitespace-nowrap"
              [ngClass]="{
                'bg-success-transparent-8 border-success': voucher.status === 'active',
                'bg-error-transparent-8 border-error-transparent-50': voucher.status === 'expired',
                'bg-warning-transparent-8 border-warning': voucher.status === 'planned',
              }"
            >
              <p class="body-medium leading-none" [innerText]="'Voucher.Status.' + voucher.status | translate"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body items-center grid grid-cols-5 gap-x-4 gap-y-1">
        <div class="body-medium text-neutral-50 col-span-2" [innerText]="'Voucher.Amount' | translate"></div>
        <div class="body-medium text-neutral-10 text-right col-span-3">
          @if (voucher.amount_type === 'P') {
            {{ voucher.amount | localizedPercentage}}
          } @else {
            {{ voucher.amount | localizedCurrency: voucher.currency }}
          }
        </div>

        <div class="body-medium text-neutral-50 col-span-2" [innerText]="'Voucher.InvoiceMonth' | translate"></div>
        <div class="body-medium text-neutral-10 text-right col-span-3">
          {{ voucher.used | localizedDate: 'MMMM yyyy' }}
        </div>
      </div>
    </div>
  }
</div>
